import { Admission } from '@domain/admission';

export const calculateChannelMaxQuantityPerTransaction = (offer: Admission) => {
  return Math.min(offer.itemsPerTransaction.max ?? 0, offer.availableItems ?? offer.itemsPerTransaction.max) ?? 0;
};
